import { PureComponent } from 'react';
import { connect } from 'unistore/react';

import {
	GetURLParams,
	kukeej,
	checkDocument,
	requestIdleCb,
} from '@utils/customLib';
import {
	actionsCombiner,
	diwaliActions,
	balanceActions,
	profileActions,
	selectStatusActions,
	loginActions,
	contestActions,
	tabFocusActions,
	onlineCheckActions,
	sidebarActions,
	userAlertActions,
	actionsRequiredActions,
	newUserActions,
} from '@utils/store/actions';
import { setSessionLanding } from '@utils/cred';

export default connect(
	'isLoggedIn, diwaliMouse, nextNotifsUpdate, isOnline',
	actionsCombiner(
		diwaliActions,
		balanceActions,
		profileActions,
		selectStatusActions,
		loginActions,
		contestActions,
		tabFocusActions,
		onlineCheckActions,
		sidebarActions,
		userAlertActions,
		actionsRequiredActions,
		newUserActions
	)
)(
	class BbLoginStuffs extends PureComponent {
		constructor(props) {
			super(props);
			const { __tabFocusStart, __onlineCheckStart } = props;

			__onlineCheckStart();
			__tabFocusStart();

			this.updateHeaderTimer = null;
		}

		componentDidMount() {
			this.rebirthFunctions();
			const { diwaliMouse, __startDiwaliThingy, isLoggedIn } = this.props;

			const urlParams = GetURLParams();
			const utmCookieInstall = [
				'utm_source',
				'utm_medium',
				'utm_campaign',
				'utm_term',
			].reduce((value, utmParam) => {
				const param = urlParams.getParams(utmParam);

				return `${value}${
					param ? `${utmParam.substr(4, 1)}_${param}~` : ''
				}`;
			}, '');
			if (utmCookieInstall) {
				kukeej.createNew(
					'sourcewa',
					utmCookieInstall.substr(0, utmCookieInstall.length - 1),
					1.23
				);
			}

			/** START Affiliate thingies */
			const affId = urlParams.getParams('aff_id');

			if (affId) {
				const clickId = urlParams.getParams('click_id');

				if (clickId) {
					this.passAffThingies(affId, clickId);
				}
			}
			/** Affiliate thingies END */

			requestIdleCb(() => {
				if (diwaliMouse) {
					__startDiwaliThingy();
				}
			}, 10000);

			this.startRebirth();

			if (isLoggedIn === 1) {
				this.runWhenLoggedIn();
			} else {
				this.runWhenLoggedOut();
			}
		}

		componentDidUpdate(prevProps) {
			const {
				isLoggedIn,
				nextNotifsUpdate,
				__fetchSideNotifs,
				isOnline,
				offlineOutTime,
			} = this.props;

			if (prevProps.isOnline !== isOnline) {
				if (checkDocument()) {
					const $rootEl = document.getElementsByTagName('html')[0];

					if (isOnline) {
						$rootEl.classList.remove('is-offline');
						if (Date.now() - offlineOutTime > 300000) {
							this.rebirthFunctions();
						}
					} else {
						$rootEl.classList.add('is-offline');
					}
				}
			}
			if (prevProps.isLoggedIn !== isLoggedIn) {
				if (isLoggedIn === 1) {
					this.runWhenLoggedIn();
				} else {
					this.runWhenLoggedOut();
				}
			}

			if (prevProps.nextNotifsUpdate !== nextNotifsUpdate) {
				const currentDate = Date.now() / 1000;

				if (currentDate < nextNotifsUpdate) {
					this.updateHeaderTimer = setTimeout(
						__fetchSideNotifs,
						(nextNotifsUpdate - currentDate) * 1000
					);
				}
			}
		}

		componentWillUnmount() {
			const { __tabFocusEnd, __onlineCheckEnd } = this.props;

			__tabFocusEnd();
			__onlineCheckEnd();
			this.runWhenLoggedOut();
			this.stopRebirth();
			clearTimeout(this.updateHeaderTimer);
		}

		passAffThingies = async (affiliate_id, click_id) => {
			const params = new URLSearchParams();

			params.append('affiliate_id', affiliate_id);
			params.append('click_id', click_id);
			try {
				setSessionLanding(params.toString());
			} catch (error) {
				console.log('setSesssionLanding', error);
			}
		};

		runWhenLoggedIn = () => {
			const {
				__checkBalances,
				__getSelectStatus,
				__getSubmittedDetails,
				__getReferralId,
				__checkKYCStatus,
				__hasBankAccount,
				__getRefStats,
			} = this.props;

			__checkBalances();
			__checkKYCStatus();
			__getSubmittedDetails();
			__getReferralId();
			__getRefStats();
			__getSelectStatus();
			__hasBankAccount();
			requestIdleCb(this.fetchUserAlerts, 7000);
		};

		runWhenLoggedOut = () => {
			const { __resetProfile, __resetBalances, __resetUserAlerts } =
				this.props;

			__resetUserAlerts();
			__resetProfile();
			__resetBalances();

			clearInterval(this.userAlertsTimeout);
		};

		fetchUserAlerts = () => {
			const { __fetchActionsRequired, __fetchUserAlerts } = this.props;

			__fetchActionsRequired();
			__fetchUserAlerts();
			this.userAlertsTimeout = setTimeout(this.fetchUserAlerts, 300000);
		};

		startRebirth = () => {
			const currMins = new Date().getMinutes();
			let retryTime = 0;

			if (currMins < 30) {
				retryTime = 30 - currMins;
			} else {
				retryTime = 60 - currMins;
			}

			this.rebirthTime = setTimeout(() => {
				this.rebirthFunctions();
				this.rebirthInterval = setInterval(
					this.rebirthFunctions,
					1800000
				);
			}, retryTime * 60 * 1000);
		};

		exchangeAlerts = () => {
			const { __fetchSideNotifs, __checkContestData } = this.props;

			__fetchSideNotifs();
			__checkContestData();
		};

		rebirthFunctions = () => {
			const { __checkLogin, isOnline } = this.props;

			if (isOnline) {
				__checkLogin();
				requestIdleCb(this.exchangeAlerts, 7000);
			}
		};

		stopRebirth = () => {
			clearInterval(this.rebirthTime);
		};

		render() {
			return null;
		}
	}
);
